import { api, handleResponse, handleError } from './apiUtils';
import { LOGIN_URL } from '../global/Constants/user';

export function auth() {
  const LOGIN_URL = '/api/external/Common/Auth';
  const loginData = {
    Login: "sirocaonline", // логин внешнего интегратора
    Password: "1d5tyyiins54454112ewdw" // пароль внешнего интегратора
  };
  return api
    .post(LOGIN_URL, loginData)
    .then(handleResponse)
    .catch(handleError);
}

